module.exports = __webpack_public_path__ + "static/media/gal2010-24.04efc373.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal2010/gal2010-24.jpg
// module id = 577
// module chunks = 0